const sessionStorageKey = 'urlFromOutsideTree';
export default sessionStorageKey;